export const FLOW_BAR_HEIGHT = 0;
export const CONTROL_BAR_HEIGHT = 60;
export const SIDEBAR_WIDTH = 300;
export const EXECUTION_MODE_HEIGHT_FRAG = 30;
